import { MdOutlineTableRestaurant } from "react-icons/md";
import "../Styles/BookNowIcon.css";
import { Link } from "react-router-dom";

function BookNowIcon() {
  return (
    <Link
      to="/book"
      className="book_now_link"
      aria-label="Book a table"
      title="Book a table"
    >
      <div className="book_now_icon">
        <svg className="book-arc-text" viewBox="0 0 100 100">
          <path
            id="circle-path"
            d="M 16,48 A 1 1, 0, 0 1 84 52"
            stroke="none"
            fill="none"
          />
          <text>
            <textPath href="#circle-path" startOffset="50%" textAnchor="middle">
              BOOK NOW
            </textPath>
          </text>
        </svg>
        <MdOutlineTableRestaurant className="table_icon" size={26} />
      </div>
    </Link>
  );
}

export default BookNowIcon;
